import { message } from "antd";
import internalApi from "../axios/internalApi";

export const getDashboardAnalytics = async (id) => {
  try {
    return await internalApi.get({
      server: "api/v1/",
      path: `admin/analytics`,
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const getBusinessAnalyticsChart = async (year) => {
  try {
    return await internalApi.get({
      server: "api/v1/",
      path: year ? `admin/chart?year=${year}` : `admin/chart`,
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};

export const getiOSDownloads = async (year) => {
  try {
    return await internalApi.get({
      server: "api/v1/",
      path: `downloads`,
    });
  } catch (error) {
    message.error(error?.data?.message);
  }
};